var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4C021C32-5634-408D-B4F3-23BEE7E844C9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---9---Comprehensive-/-OD---Enter-IDV---1",
    transform: "translate(-637.000000, -369.000000)",
    fill: "#605F5E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(100.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(343.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy-6",
    transform: "translate(50.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151,3 C147.134062,3 144,6.1340625 144,10 C144,13.8659375 147.134062,17 151,17 C154.865938,17 158,13.8659375 158,10 C158,6.1340625 154.865938,3 151,3 Z M150.763575,5.4137931 C151.482772,5.4137931 152.183796,5.65665386 152.727188,6.08390964 C153.270579,6.51114345 153.655172,7.14202967 153.655172,7.87441256 C153.655172,8.5881532 153.473666,9.09105445 153.18557,9.45074935 C152.897458,9.81044425 152.543427,10.0151637 152.240512,10.2251871 C151.937623,10.4351917 151.67869,10.6407774 151.476596,11.0051485 C151.274501,11.3694883 151.125695,11.9119965 151.125695,12.7956515 L151.125822,12.7955289 C151.120643,12.9860407 150.959978,13.137931 150.763572,13.137931 C150.567288,13.137931 150.406625,12.9860375 150.401451,12.7955289 C150.401451,11.8337585 150.569694,11.1624493 150.84289,10.6699677 C151.115969,10.1775174 151.491111,9.88329002 151.82177,9.65390253 C152.152461,9.42452759 152.42123,9.25033244 152.608288,9.01677084 C152.795353,8.78322807 152.930883,8.47881339 152.930883,7.87444686 C152.930883,7.37647295 152.686853,6.947513 152.280139,6.62764471 C151.873428,6.30790196 151.310216,6.11692879 150.763688,6.11692879 C149.659606,6.11692879 148.768257,6.87150034 148.57942,7.60535829 C148.560221,7.69987824 148.501994,7.7826291 148.418249,7.83424364 C148.334505,7.88585818 148.232575,7.90179196 148.136326,7.87850171 C148.040078,7.85508623 147.957979,7.79440133 147.909098,7.71066815 C147.860217,7.62681257 147.848848,7.52726486 147.877773,7.43507676 C148.161462,6.33245386 149.330589,5.41399374 150.76368,5.41399374 L150.763575,5.4137931 Z M150.758621,13.6206897 C151.025306,13.6206897 151.241379,13.8367544 151.241379,14.1034483 C151.241379,14.3700215 151.025427,14.5862069 150.758621,14.5862069 C150.491935,14.5862069 150.275862,14.3701422 150.275862,14.1034483 C150.275862,13.8368751 150.491927,13.6206897 150.758621,13.6206897 Z",
    id: "Shape-Copy-8"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.216e5c585fb77f4cb12f60eee9a572f4.svg";
export { ForwardRef as ReactComponent };